<ion-content id="modalContent" padding>
  <div class="container">
    <ion-label class="diversity-check-text" color="title">
      <p>
        {{ 'diversityCheck.ModalText' | translate }}
      </p></ion-label
    ><br />
    <div class="acceptance-check">
      <ion-checkbox mode="ios" [(ngModel)]="accepted"></ion-checkbox>
      <ion-button
        mode="ios"
        color="primary"
        (click)="accept()"
        [disabled]="!accepted || loading"
      >
        {{ 'diversityCheck.Accept' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>
